import { render, staticRenderFns } from "./summary-page.vue?vue&type=template&id=24b265d8&scoped=true"
import script from "./summary-page.vue?vue&type=script&lang=ts"
export * from "./summary-page.vue?vue&type=script&lang=ts"
import style0 from "./summary-page.vue?vue&type=style&index=0&id=24b265d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b265d8",
  null
  
)

export default component.exports